import React from 'react';
import {withTranslation} from "react-i18next";

export default withTranslation()(EmbeddedPdf);

function EmbeddedPdf(props) {

    return (
        <div>
            <iframe
                src={props.src}
                key={props.src}
                className="embed-document__item border border-primary"
                frameBorder="0"
                scrolling="no"
            />

        </div>
    );
}
